import { ProgramBroadcastFiltersState } from '@/stores/program-broadcast-filters';
import { ParamsWithPagination } from '@/types/api';

import { TProgramBroadcastFilters } from '../types';

export const broadcastScheduleQueryKeys = {
  all: ['broadcastSchedules'] as const,
  broadcastSchedule: () => [...broadcastScheduleQueryKeys.all, 'broadcastSchedule'] as const,
  id: (id: string, filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...broadcastScheduleQueryKeys.all, 'broadcastSchedule', id, filters] as const,
  segment: (id: string) =>
    [...broadcastScheduleQueryKeys.all, 'broadcastSchedule', 'segment', id] as const,
  segments: (id: string, filters?: Partial<ProgramBroadcastFiltersState>) =>
    [...broadcastScheduleQueryKeys.all, 'broadcastSchedule', id, 'segments', filters] as const,
  activeOptionSegments: (id: string) =>
    [...broadcastScheduleQueryKeys.all, 'broadcastSchedule', id, 'activeOptionSegments'] as const,

  lists: () => [...broadcastScheduleQueryKeys.all, 'list'] as const,
  list: (params?: ParamsWithPagination<TProgramBroadcastFilters>) =>
    [...broadcastScheduleQueryKeys.all, 'list', params] as const,
};
